<template>
  <div class="chat-log pa-5 pt-0">
    <div
      v-for="message in widget.data.rows"
      class="chat-group d-flex align-start pt-0"
      :class="[{'flex-row-reverse': widget.data.me.id !== message.fromUserId}, { 'mb-8': widget.data.me.id !== message.fromUserId }]"
    >
      <div
        class="chat-body d-inline-flex flex-column"
        :class="widget.data.me.id !== message.fromUserId ? 'align-end' : 'align-start'"
        style="flex: 1 ; border:1px solid lightgray"
      >
        <p
          class="chat-content py-3 px-4 elevation-1"
          :class="[
                      widget.data.me.id === message.fromUserId ? 'primary white--text chat-right' : 'secondary  white--text chat-left',
                      widget.data.me.id !== message.fromUserId ? 'mb-2' : 'mb-1'
                    ]"
          style="width: 100%"
        >
                    <span style="float: left">
                      {{ convertDate(message.createdAt) }}
                    </span>
          <span
            class="text-xs me-1 text-white float-right pt-1"
            style="text-align: left ; font-size: 1em !important;"
          > {{ widget.data.me.id !== message.fromUserId ? message.fromUser.fullName : "خودم" }} </span>
        </p>
        <span
          style="width: 100% ; padding: 15px"
          v-if="message.content!=='null'"
          v-html="message.content.replace(/@@@baseUrl@@@/g, baseUrlRaw)"
        >
                  </span>
        <div
          v-if="message.isRefer || message.files.length>0"
          class="pa-3 pb-3 float-right d-flex"
          style="width: 100% ; border-top: 1px solid lightgray"
        >
          <span v-if="message.isRefer" style="width: 300px " class="pt-2">
          ارجاع شد به {{ message.toUser.fullName }}
            </span>
          <span  style="flex: 1 ; text-align: left" v-if="message.files.length>0">
          <v-btn
            v-for="file in message.files" :key="file.id+'file'"
            class="ma-1"
           :href="file.link"
            target="_blank"
            icon
            small
            outlined
            :color="file.type==='pdf'  ? 'error' : file.type==='jpg' || file.type==='png'  ? 'primary' :  ' black' ">
             <v-icon>
              {{ file.type==='pdf'  ? mdiFilePdf : file.type==='jpg' || file.type==='png'  ? mdiImage:  mdiFile   }}
            </v-icon>
          </v-btn>
             <span> : فایل های پیوست </span>
            </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import baseConfig from '@/../baseConfig'
import moment from "jalali-moment";
import {
  mdiFilePdf,
  mdiImage,
  mdiFile
} from "@mdi/js";

export default {
  name: "ticket-activities",
  props: {
    widget: Object
  },
  data() {
    return {
      baseUrlRaw: baseConfig.basUrlRaw,
      mdiFilePdf: mdiFilePdf,
      mdiImage: mdiImage,
      mdiFile: mdiFile,
    }
  },
  methods: {
    downloadFile(url, fileName){
      fetch(url, { method: 'get', mode: 'no-cors', referrerPolicy: 'no-referrer' })
        .then(res => res.blob())
        .then(res => {
          const aElement = document.createElement('a');
          aElement.setAttribute('download', fileName);
          const href = URL.createObjectURL(res);
          aElement.href = href;
          // aElement.setAttribute('href', href);
          aElement.setAttribute('target', '_blank');
          aElement.click();
          URL.revokeObjectURL(href);
        });
    },
  generateIcon(icon) {
    return eval('this.' + icon)
  },
    convertDate(date) {
      return moment.from(date, 'en', 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD');
    }
  }
}
</script>

<style scoped>

</style>
